import { useEffect } from "react";
import { useRef, useState } from "react";
import { useHistory } from "react-router";
import { endPoints } from "../../config/end-points";
import useHttp from "../../hooks/use-http";
import { cuteToast } from "../UI/cute";
import Input from "../UI/Input";
// import { access_specifier } from "../../config/app.config";

const TemplateForm = (props) => {
  
  const templateNameRef = useRef();
  const thumbUrlRef = useRef();
  const prevUrlRef = useRef();
  const jsonDataRef = useRef();
  const productRef = useRef();
  var templateDetail = props.templateDetail;
  // console.log(templateDetail);
  const [template, setTemplate] = useState({
    id: "",
    template_Name: "",
    thumbUrl: "",
    prevUrl: "",
    jsonData: "",
    product_name : "",
  });

  const {sendRequest: fetchAccess} = useHttp();
  const [access_specifier, setAccess_specifier] = useState({});
  const [access, setAccess] = useState(",9S,");
  const [lists, setLists] = useState({});

  const { sendRequest } = useHttp();
  const {sendRequest: getSubdomainData} = useHttp();
  const [allaccess, setAllAccess] = useState({});
  
  const history = useHistory();

  useEffect(() => {
    // console.log(templateDetail);
    if (templateDetail) {
      setTemplate({
        id: templateDetail.id,
        product_name: templateDetail.type,
        template_Name: templateDetail.name,
        thumbUrl: templateDetail.thumbnail_url,
        prevUrl: templateDetail.preview_url,
        jsonData: templateDetail.slide_data
      });
      if(templateDetail.access){
        setAccess(templateDetail.access);
      }
      showAccess(templateDetail.type);
    }
    // eslint-disable-next-line
  }, [templateDetail]);

  useEffect(() => {
    getSubdomainData({
        url: endPoints.getProductDetails,
        method: "GET",
    }, (response) => {
        if (response.status === 200 && response.body.length > 0) {
            const result = response.body;
            setLists(result)
                
        }
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, []);

useEffect(  () => {
      fetchAccess({
          url: endPoints.fetchAccess,
          method: "GET",
      },(response)=>{
          // console.log(response)
          if(response.status === 200 && response.body.length > 0){
              // console.log(response.body)
              const result = response.body
              if(result){
                  setAllAccess(result)
              }
          }
      })
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const default_access = {
    // "9A": "Admin", //Admin
    // "91" : "JV access", //JV;
  };

  // to remove admin access from access_specifier
  delete access_specifier["5"];
  delete access_specifier["9S"];


  const app_all_access = {...default_access,...access_specifier};
  // console.log(app_all_access)

  const handleChange = (e, access_id) => {
    // access_id= "p" + access_id + "q";
    var new_Access = access.split(",");

    if ( !access.includes("9S")) {
      cuteToast({
        type: "error",
        message: "",
        timer: 5000,
        title: "Primary Access Required",
      });
    }

    if (e.target.checked) {
      setAccess(access +  access_id + ",");
    } else {
      var new_Access1 = new_Access.filter((access) => {
        // return parseInt(access) !== parseInt(access_id);
        return (access) !== (access_id);
      });
      setAccess(new_Access1.toString());
    }

    console.log(access);
    
  };

  const checkAccess = (access1) => {
    // return access;
    // console.log(access1,access);
    if(access1 === "8"){
      if (access.includes("8,")) return "checked";
    }else{
      if (access.includes(access1)) return "checked";
    }

  };
  

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(templateNameRef.current.val());

    if (!templateNameRef.current.val()) {
      templateNameRef.current.addClassName("form-control invalid");
      templateNameRef.current.focus();
      return false;
    } else {
      templateNameRef.current.addClassName("form-control");
    }

    if (!thumbUrlRef.current.val()) {
      thumbUrlRef.current.addClassName("form-control invalid");
      thumbUrlRef.current.focus();
      return false;
    } else {
      thumbUrlRef.current.addClassName("form-control");
    }

    if (!prevUrlRef.current.val()) {
      prevUrlRef.current.addClassName("form-control invalid");
      prevUrlRef.current.focus();
      return false;
    } else {
      prevUrlRef.current.addClassName("form-control");
    }
    
    if (!jsonDataRef.current.value) {
      jsonDataRef.current.classList.add("invalid");
      jsonDataRef.current.focus();
      return false;
    } else {
      jsonDataRef.current.classList.add("form-control");
    }

    if (!productRef.current.value) {
      productRef.current.classList.add("invalid");
      productRef.current.focus();
      return false;
    } else {
      productRef.current.classList.add("form-control");
    }
    
    // console.log(template);

    if ( !access.includes("9S")) {
      cuteToast({
        type: "error",
        message: "",
        timer: 5000,
        title: "Primary Access Required",
      });

      return false;
    }

    const url = template.id
      ? endPoints.updateTemplate + "/" + template.id
      : endPoints.createTemplate;

    sendRequest(
      {
        url: url,
        method: "POST",
        body: {
          product_name: productRef.current.value,
          template_Name: templateNameRef.current.val(),
          thumbUrl: thumbUrlRef.current.val(),
          prevUrl: prevUrlRef.current.val(),
          jsonData: jsonDataRef.current.value,
          access: access
        },
      },
      (response) => {
        if (response.status === 202) {
          cuteToast({
            type: "error",
            message: "",
            timer: 5000,
            title: response.message,
          });
        } else {
          cuteToast({
            type: "success",
            message: "",
            timer: 5000,
            title: response.message,
          });

          if (!template.id) {
            setTemplate({
              template_Name: "",
              thumbUrl: "",
              prevUrl: "",
              jsonData: "",
            });
            history.push("/alltemplates/");
          }
        }
      }
    );

    console.log("Form Submit");
  };

  const showAccess = (access) => {
    const new_Access = {};
    Object.keys(allaccess).map((item) => {
      // console.log(allaccess[item].id);
      if(allaccess[item].product_name === access)
      new_Access[allaccess[item].access_code] = allaccess[item].access_name;
       return null;
    });
    setAccess_specifier(new_Access);
  };

  const handleSubdomainChange = (event) => {

    const { value } = event.target; 
    setTemplate({...template,product_name:value})

    showAccess(value);

    // const subdomain_detail = lists.find(element => element.subdomain_name === value);
    
    // if(subdomain_detail){
    //   const new_Access = {};
    //   Object.keys(allaccess).map((item, index) => {
    //     // console.log(allaccess[item].id);
    //     if(subdomain_detail.product_access.includes(allaccess[item].id))
    //     new_Access[allaccess[item].id] = allaccess[item].access_name;
    //      return null;
    //   });

    //   setAccess_specifier(new_Access);
    // }
    
};

  const jsonUpload = (event) => { 
    const file = event.target.files[0];
    const reader = new FileReader();
  
    reader.onload = (event) => {
      const fileContent = event.target.result;
      // const jsonData = JSON.parse(fileContent);
      // console.log(jsonData);
      setTemplate({ ...template, jsonData: fileContent })
      // Do something with the JSON data
    };
    
    // console.log(file);
    reader.readAsText(file);
  };

  return (
    <>
      <form onSubmit={handleSubmit}>
        <div className="row">
          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">Template Name</label>
              <Input
                type="text"
                placeholder="Enter Template Name"
                inputClass="form-control"
                value={template.template_Name}
                ref={templateNameRef}
                onChange={(e) =>
                  setTemplate({ ...template, template_Name: e.target.value })
                }
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">Thumbnail Url</label>
              <Input
                type="text"
                placeholder="Enter Thumbnail Url"
                inputClass="form-control"
                value={template.thumbUrl}
                onChange={(e) =>
                  setTemplate({ ...template, thumbUrl: e.target.value })
                }
                ref={thumbUrlRef}
              />
            </div>
          </div>

          <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label">Preview Url</label>
              <Input
                type="text"
                placeholder="Enter Preview Url"
                inputClass="form-control"
                ref={prevUrlRef}
                value={template.prevUrl}
                onChange={(e) => setTemplate({ ...template, prevUrl: e.target.value })}
              />
            </div>
          </div>

          {/* <div className="col-md-12">
            <div className="mb-3">
              <label className="form-label"><b>Json Data</b></label>
              <Input
                type="text"
                placeholder="Enter Json Data"
                inputClass="form-control"
                ref={jsonDataRef}
                value={template.jsonData}
                onChange={(e) => setTemplate({ ...template, jsonData: e.target.value })}
              />
            </div>
          </div> */}
        </div>
        <div className="row">     
          <div className="col-md-6">
            <div className="mb-3">
              <label className="form-label"><b>Json Data</b></label>
              <textarea type="text" placeholder="Enter Json Data" className="form-control jsondata" ref={jsonDataRef}
                onChange={(e) => setTemplate({ ...template, jsonData: e.target.value })} value={template.jsonData} rows='4' >
              </textarea>
            </div>
          </div>
          <div className="col-md-6 m-auto">
            <div className="mb-3 d-flex ">
              <label className="form-label mt-2"><b>Or</b></label>
              <input
                  className={`form-control mx-3 font12 `}
                  type="file"
                  onChange={(e)=>jsonUpload(e)}
              />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
              <div className="mb-3">
                  <label className="form-label" htmlFor="inputName"><b>Subdomain List *</b></label>
                  <select
                      type="text"
                      className="form-control"
                      onChange={handleSubdomainChange}
                      // onChange={(e) => setTemplate({...template,product_name:e.target.value})}
                      ref={productRef}
                      value={template.product_name}
                  >
                      <option value="">Select Subdomain</option>
                      {lists && lists.length > 0 && lists.map((item, index) => {

                          return (
                              <option key={index}  value={item.subdomain_name}>{item.subdomain_name}</option>
                          )
                      })
                      }

                  </select>
              </div>
          </div>

          <hr />
          
          <div className="col-md-12">
            <h6>Access : </h6>
            <ul>
              { app_all_access && Object.keys(app_all_access).map((access_id, index) => {
                const product_name = app_all_access[access_id];
                const check = checkAccess(access_id);
                // console.log(app_all_access);
                return (
                  <li key={index} className="access_span">
                    {check && (
                      <input
                        type="checkbox"
                        checked
                        onChange={(e) => {
                          handleChange(e, access_id);
                        }}
                      />
                    )}
                    {!check && (
                      <input
                        type="checkbox"
                        onChange={(e) => {
                          handleChange(e, access_id);
                        }}
                      />
                    )}{" "}
                    {product_name}
                  </li>
                );
              })}
            </ul>
          </div>
          <div className="col-md-12 mt-3">
            <button type="reset" className="btn btn-danger">
              Reset
            </button>
            <button type="submit" className="btn pull-right">
              {template.id ? "Update" : "Create"}
            </button>
          </div>
        </div>
      </form>
    </>
  );
};

export default TemplateForm;
